const routers = [
  {
    // 打印包装票据
    path: '/packagenote/list',
    name: 'packagenote',
    component: () => import('@/views/modules/plate/packagenote/List.vue')
  },
  {
    // 担当
    path: '/undertake/list',
    name: 'undertake',
    component: () => import('@/views/modules/plate/undertake/List.vue')
  },
  {
    // 打印库位码
    path: '/printposition/list',
    name: 'printposition',
    component: () => import('@/views/modules/plate/printposition/List.vue')
  },
  {
    // 板块汇总
    path: '/platesummary/list',
    name: 'platesummary',
    component: () => import('@/views/modules/plate/platesummary/List.vue')
  },
  {
    // 资材移库
    path: '/materialadjustment/list',
    name: 'materialadjustment',
    component: () => import('@/views/modules/plate/materialadjustment/List.vue')
  },
  {
    // 车间移库
    path: '/storeadjustment/list',
    name: 'storeadjustment',
    component: () => import('@/views/modules/plate/storeadjustment/List.vue')
  },
  {
    // 出入库明细
    path: '/outinstoredetail/list',
    name: 'outinstoredetail',
    component: () => import('@/views/modules/plate/outinstoredetail/List.vue')
  },
  {
    // 二楼搜索
    path: '/twofloor/list',
    name: 'twofloor',
    component: () => import('@/views/modules/plate/twofloor/List.vue')
  },
  {
    // 三楼搜索
    path: '/threefloor/list',
    name: 'threefloor',
    component: () => import('@/views/modules/plate/threefloor/List.vue')
  }
]
export default routers
